import React from 'react';
import { MarginProps } from '../../../theme/styledProps';
import { Select } from '../../../CommonComponents/OPL/Select/Select/Select';
import { Wrapper } from '../../../CommonComponents/OPL/Wrapper/Wrapper';
import {
  EntityType,
  PortfolioReportParamDTO,
  usePortfolioReportCache,
} from '../../api/usePortfolioReportParamsQuery';
import { EntitySelect } from '../EntitySelect/EntitySelect';

interface Props extends MarginProps {
  param: PortfolioReportParamDTO;
}

export const EntityTypeSelect: React.FC<Props> = ({ param, ...rest }) => {
  const { mutateParamCache, mutateInceptionDate } = usePortfolioReportCache();

  const value = param.values ? param.values[0] : null;

  const childParamId = (param.childParameterIds && param.childParameterIds[0]) || null;

  if (!param.options) {
    return null;
  }

  return (
    <Wrapper {...rest}>
      <Select
        label={param.displayName || undefined}
        value={value ? param.options.find(({ value: _value }) => value === _value) : null}
        options={param.options}
        onChange={option => {
          if (option) {
            mutateParamCache(param.id, { values: [option.value] });

            if (option.value === EntityType.Household && param.dateRangeParameterId) {
              mutateInceptionDate(param.dateRangeParameterId, param.householdInceptionDate);
            }

            if (childParamId) {
              mutateParamCache(childParamId, { values: null });
            }
          }
        }}
      />

      {childParamId && (
        <EntitySelect
          paramId={childParamId}
          dateRangeParamId={param.dateRangeParameterId}
          selectedEntityType={value}
          mt="16"
        />
      )}
    </Wrapper>
  );
};
